import { ModalActionDef, ModalDefine, ModalStatus } from '@/libs/formHelper/modalForm/type'
import { Genealogy } from '@/api/genealogy/Genealogy'

export default function getModalDefine (view: any): ModalDefine<Genealogy> {
  const items = [
    // {
    //   title: '族谱图',
    //   type: {
    //     module: 'imageUrl'
    //   },
    //   required: true,
    //   key: 'imageUrl'
    // },
    {
      title: '族谱名称',
      labelWidth: 100,
      col: { span: 12 },
      required: true,
      key: 'name',
      type: {
        module: 'text',
        maxlength: 10
      }
    },
    {
      title: '族谱姓氏',
      labelWidth: 100,
      col: { span: 12 },
      required: true,
      key: 'surName',
      type: {
        module: 'text',
        maxlength: 10
      }
    },
    {
      title: '联系人姓名',
      labelWidth: 100,
      col: { span: 12 },
      required: true,
      key: 'contacts',
      type: {
        module: 'text',
        maxlength: 10
      }
    },
    {
      title: '联系人手机',
      labelWidth: 100,
      col: { span: 12 },
      required: true,
      key: 'phone',
      type: {
        module: 'text',
        maxlength: 11
      }
    },
    {
      title: '选择村庄',
      labelWidth: 100,
      required: true,
      col: { span: 12 },
      key: 'villageId',
      slot: 'selectVillage'
    },
    {
      title: '族谱简介',
      labelWidth: 100,
      col: { span: 24 },
      key: 'introduction',
      required: false,
      type: {
        module: 'textarea',
        limit: 300
      }
    }
  ]

  const actions: ModalActionDef<Genealogy>[] = [
    {
      key: 'create',
      title: '创建',
      type: 'submit',
      button: 'success',
      actionClose: true,
      modalStatus: ModalStatus.ADD,
      onClick: (item: Genealogy) => {
        return view.onInsertItem(item)
      }
    },
    {
      key: 'modi',
      title: '保存',
      type: 'submit',
      button: 'success',
      actionClose: true,
      modalStatus: ModalStatus.MODI,
      onClick: (item: Genealogy) => {
        return view.onUpdateItem(item)
      }
    }
  ]

  return {
    items,
    actions
  }
}
